import InputNumber from './InputNumber';

export default InputNumber;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/input-number/index.js
// module id = 155
// module chunks = 0